export default "__VITE_ASSET__3614ef37__"